"use strict";

var _classCallCheck = require("/home/runner/work/typedraft-playground/typedraft-playground/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/typedraft-playground/typedraft-playground/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var MethodCode =
/*#__PURE__*/
function () {
  function MethodCode(path) {
    _classCallCheck(this, MethodCode);

    this.m_Path = path;
  }

  _createClass(MethodCode, [{
    key: "ToClassMethod",
    value: function ToClassMethod() {
      var _this$m_Right = this.m_Right,
          id = _this$m_Right.id,
          raw_params = _this$m_Right.params,
          body = _this$m_Right.body,
          typeParameters = _this$m_Right.typeParameters;
      var params = raw_params.filter(function (param) {
        if (types_1.isIdentifier(param) && param.name === "this") {
          return false;
        }

        return true;
      });
      var kind = id.name === "constructor" ? id.name : "method";
      var class_method = types_1.classMethod(kind, id, params, body);
      class_method.typeParameters = typeParameters;
      return class_method;
    }
  }, {
    key: "m_Code",
    get: function get() {
      return this.m_Path.node;
    }
  }, {
    key: "m_Left",
    get: function get() {
      return this.m_Expression.left;
    }
  }, {
    key: "m_Right",
    get: function get() {
      return this.m_Expression.right;
    }
  }, {
    key: "m_Expression",
    get: function get() {
      return this.m_Code.expression;
    }
  }, {
    key: "m_ClassName",
    get: function get() {
      return this.m_Left.openingElement.name.name;
    }
  }]);

  return MethodCode;
}();

exports.MethodCode = MethodCode;

var types_1 = require("@babel/types");